// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
export const LoginResponseFailureFragmentDoc = gql`
    fragment loginResponseFailure on LoginResponseFailure {
  __typename
  code
  message(locale: $locale)
}
    `;